module.exports = __webpack_public_path__ + "static/dark-yellow2-36e2e015f67be43d8eb614fc68affe86.png";